import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'slide-banner',
    template: require('./slide.component.html'),
    styles: [require('./topdetail.component.scss')],
})
export class SlideBannerComponent implements OnInit, OnChanges {
    @Input() imgData: any;
    constructor() { }
    isBlock = false;
    ngOnChanges(changes: SimpleChanges): void {
        // console.log(changes)
    }
    ngOnInit() {
        setTimeout(() => {
            this.isBlock = true;
        }, 3000);
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/shared/topdetail/slide.component.ts